export const MenulistURL = {
  Menulist: 'Menulist',
};
